var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoad5({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 22,
    viewBox: "0 0 38 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.86001 21.25C3.86001 17.72 2.63001 14.46 0.570007 11.89C6.16001 9.99995 11.81 8.13995 17.43 6.27995C23.01 4.43995 28.6 2.58996 34.14 0.709961V0.799957C34.14 4.33996 35.37 7.58996 37.43 10.16C31.84 12.05 26.19 13.91 20.57 15.77C14.99 17.61 9.40001 19.46 3.86001 21.33V21.25Z",
    fill: "#DDDDDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoad5);
export default __webpack_public_path__ + "static/media/road_5.9c8eb50c8e0a669906a9150120b1bfc4.svg";
export { ForwardRef as ReactComponent };